import React from "react";
import { Link, type LinkProps } from "react-router-dom";

import { FontAwesomeIcon, type FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import cx from "classnames";

import styles from "./InlineButton.module.css";

type InlineButtonProps = {
	font?: "inherit" | "body" | "subtext";
};

export const InlineButton = React.forwardRef<
	HTMLButtonElement,
	React.ButtonHTMLAttributes<HTMLButtonElement> & InlineButtonProps
>(({ font = "inherit", ...rest }, ref) => {
	const className = cx(styles.inlineButton, rest.className, styles[`font-${font}`]);

	return <button {...rest} ref={ref} className={className} />;
});

InlineButton.displayName = "InlineButton";

export const InlineAnchor = React.forwardRef<
	HTMLAnchorElement,
	React.AnchorHTMLAttributes<HTMLAnchorElement> & InlineButtonProps
>(({ font = "inherit", ...rest }, ref) => {
	const className = cx(styles.inlineButton, rest.className, styles[`font-${font}`]);

	return <a {...rest} ref={ref} className={className} />;
});

InlineAnchor.displayName = "InlineAnchor";

export const InlineLink = React.forwardRef<HTMLAnchorElement, LinkProps & InlineButtonProps>(
	({ font = "inherit", ...rest }, ref) => {
		const className = cx(styles.inlineButton, rest.className, styles[`font-${font}`]);

		return <Link {...rest} ref={ref} className={className} />;
	},
);

InlineLink.displayName = "InlineLink";

export const LabelIconForInlineButton = React.forwardRef<
	SVGSVGElement,
	FontAwesomeIconProps & { side: "left" | "right" }
>(({ icon, className, side, ...rest }, ref) => {
	return (
		<FontAwesomeIcon
			ref={ref}
			icon={icon}
			className={cx(styles.labelIcon, styles[`labelIcon-${side}`], className)}
			{...rest}
		/>
	);
});

LabelIconForInlineButton.displayName = "LabelIconForInlineButton";

export default InlineButton;
